import * as yup from 'yup';

export const initialValues = {
  sku: '',
  washHub: '',
  skuId: '',
  size: '',
  type: '',
  items: [''] as string[],
};

export const validationSchema = yup.object().shape({
  sku: yup.string().required('SKU is required'),
  washHub: yup.string(),
  items: yup.array().of(yup.string().required('Item ID is required')),
});
